import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { Rate } from '@/modules/backend/Entities/Rate';
import homeSmartApi from '@/plugins/HomeSmartApi';
import { CreateRateData } from '@/modules/backend/Dto/CreateRateData';
import { EditRateData } from '@/modules/backend/Dto/EditRateData';

/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class RatesModule
 */
@Module({ namespaced: true, name: 'dashboard/rates', store })
export class RatesModule extends VuexModule {
  public get rates(): Rate[] {
    return this.items;
  }

  public get isLoaded(): boolean {
    return this.loaded;
  }

  private items: Rate[] = [];
  private loaded = false;

  @Action
  public async fetch(buildingId: number): Promise<void> {
    this.context.commit('changeLoaded', true);
    const items = await homeSmartApi.Rates.Get(buildingId);
    this.context.commit('set', items);
    this.context.commit('changeLoaded', false);
  }

  @Action
  public async fetchForAccount(accountId: number): Promise<void> {
    this.context.commit('changeLoaded', true);
    const items = await homeSmartApi.Rates.getForAccount(accountId);
    this.context.commit('set', items);
    this.context.commit('changeLoaded', false);
  }

  @Action({ rawError: true })
  public async create(payload: CreateRateData): Promise<void> {
    try {
      this.context.commit('changeLoaded', true);
      const item = await homeSmartApi.Rates.Create(payload);
      this.context.commit('add', item);
    } finally {
      this.context.commit('changeLoaded', false);
    }
  }

  @Action
  public async reset(buildingId: number): Promise<void> {
    const rates = await homeSmartApi.Rates.reset(buildingId);
    this.context.commit('set', rates);
  }

  @Action
  public async edit(payload: EditRateData): Promise<void> {
    const item = await homeSmartApi.Rates.Edit(payload);
    this.context.commit('replace', item);
  }

  @Action
  public async remove(rateId: number): Promise<void> {
    await homeSmartApi.Rates.remove(rateId);
  }

  @Mutation
  private set(payload: Rate[]): void {
    this.items = payload;
  }

  @Mutation
  private add(payload: Rate): void {
    const addItems: Rate[] = this.items;
    addItems.forEach((item: Rate, i) => {
      if (payload.getResource().getId() === item.getResource().getId()) {
        addItems[i] = payload;
      }
    });

    this.items = [];
    this.items = this.items.concat(addItems);
  }

  @Mutation
  private replace(payload: Rate): void {
    this.items = this.items.map((item) => item.getId() === payload.getId() ? payload : item);
  }

  @Mutation
  private changeLoaded(payload: boolean): void {
    this.loaded = payload;
  }
}
